"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _propTypes = require("prop-types");

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _IconChevronDown = _interopRequireDefault(require("./IconChevronDown"));

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
} // Copyright © VNG Realisatie 2020
// Licensed under the EUPL
//


var IconFlippingChevron = /*#__PURE__*/(0, _styledComponents["default"])(_IconChevronDown["default"]).withConfig({
  // Prevent props being passed to svg element
  shouldForwardProp: function shouldForwardProp(prop, defaultValidator) {
    return !['flipHorizontal', 'animationDuration'].includes(prop) && defaultValidator(prop);
  }
}).withConfig({
  displayName: "IconFlippingChevron",
  componentId: "sc-ccos5v-0"
})(["fill:", ";transition:", "ms ease-in-out;", ""], function (p) {
  return p.theme.colorText;
}, function (p) {
  return p.animationDuration;
}, function (p) {
  return p.flipHorizontal ? (0, _styledComponents.css)(["transform:rotate(180deg);"]) : '';
});
IconFlippingChevron.propTypes = {
  flipHorizontal: _propTypes.bool,
  animationDuration: _propTypes.number
};
IconFlippingChevron.defaultProps = {
  animationDuration: 150
};
var _default = IconFlippingChevron;
exports["default"] = _default;